<template>
  <div v-if="dashboardLayout.mapping != null" class="dashboard-body">
    <b-row v-for="(rowQuery, index) in dashboardLayout.mapping" :key="index">
      <template v-for="(colQuery, idx) in rowQuery">
        <b-col :cols="colQuery.column" :key="idx">
          <b-row
            v-if="colQuery.cards != null && colQuery.cards.length > 0"
            class="center-content max-row-height"
          >
            <b-col v-for="(cardQuery, i) in colQuery.cards" cols="12" :key="i">
              <div
                v-if="
                  dashboardLayout.data != null &&
                  dashboardLayout.data[cardQuery] != null
                "
                class="max-height-panel"
              >
                <b-card no-body class="max-height-card">
                  <GlobalDashboardCard
                    :cardConfig="dashboardLayout.data[cardQuery]"
                    :layoutData="dashboardLayout"
                    :data="dashboardData"
                    class="h-100"
                  >
                  </GlobalDashboardCard>
                </b-card>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import GlobalDashboardCard from "@/views/components/dashboard/GlobalDashboardCard";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    BCard,
    GlobalDashboardCard,
  },
  props: {
    dashboardLayout: { default: {} },
    dashboardFunction: { default: () => {} },
  },
  setup(props) {
    let dashboardData = {
      data: {},
    };

    let dashboardFunction = {
      dashboardData: dashboardData,
    };

    if (props.dashboardFunction != null) {
      props.dashboardFunction(dashboardFunction);
    }

    return {
      dashboardData,
    };
  },
};
</script>

<style scoped>
.center-content {
  justify-content: center;
}

.max-row-height {
  height: 100%;
}

.max-height-panel {
  height: calc(100% - 2rem);
}

.max-height-card {
  height: 100%;
  border-radius: 1.428rem !important;
}
</style>
